import { queryAll, query, fromId } from '../utils/utils.js';

export class TwoColumnBlock {
    root = query('body');

    constructor() {
        queryAll('.two-column-block').forEach((twoColumnBlock) => {

            twoColumnBlock.querySelectorAll('.row > .col').forEach((el) => {

                this.groupHeadlineElements( el )

            } );

        });
    }

    groupHeadlineElements( col  ) {

        const firstElm = col.firstElementChild;
        
        // loop through all siblings of firstElm and check if they're paragraphs ///
        let nextElm = firstElm.nextElementSibling;
        let paragraphs = [];
        
        while( nextElm ) {
            if( nextElm.tagName === 'P' ) {
                paragraphs.push( nextElm );
            } else {
                break;
            }
            nextElm = nextElm.nextElementSibling;
        }

        if( firstElm && firstElm.tagName === 'H3' && firstElm.classList.contains('wp-block-heading') && paragraphs.length > 0 ) {
            const l2headline = document.createElement('div');
            l2headline.classList.add('level2-headline');

            col.replaceChild(l2headline, firstElm);

            l2headline.appendChild(firstElm);

            paragraphs.forEach((p) => {
                l2headline.appendChild(p);
            });
        }

    }
}
